import React from 'react';
import { useCarousel } from 'src/shared/design-system/DishFirst/Carousel';
import { useRefState } from 'src/shared/hooks/useRefState';
import { Mixins, Spacing } from 'web-common/src/shared/styles';
import { Container, Row, RowScrollButtons, SegmentDivider } from './styles';
import { FilterCardRowProps } from './types';

export const FilterCardRow: React.FC<FilterCardRowProps> = (props) => {
  const { children, data } = props;
  const [ref, setRef] = useRefState<HTMLDivElement>();
  const [dividerRef, setDividerRef] = useRefState<HTMLDivElement>();

  const onScreenThreshold = Mixins.Spacing.getSpacingValue(Spacing.DOUBLE);
  const segmentDividerWidth = 43;
  const { scrollLeft, scrollRight, hasOverflow, numElementsLeft, numElementsRight } = useCarousel({
    ref,
    content: data,
    onScreenThreshold,
    dividerRef,
    segmentDividerWidth,
  });

  return (
    <Container>
      <Row ref={setRef}>{children}</Row>
      {hasOverflow && (
        <RowScrollButtons
          elementName={'browse-by-tags-filters'}
          scrollRight={scrollRight}
          scrollLeft={scrollLeft}
          numElementsLeft={numElementsLeft}
          numElementsRight={numElementsRight}
        />
      )}
      <SegmentDivider ref={setDividerRef} />
    </Container>
  );
};
